<template>
<div>
    <v-content-layout>
        <template #header>
            <FilterOption @onFilter="onFilter" />
            <v-spacer></v-spacer>
            <el-button class="mr-2" type="plain" @click="onViewParsers">Brands</el-button>
            <el-dropdown trigger="click">
                <el-button :loading="exportLoading" :disabled="exportLoading" type="primary">
                    Export Table <i class="el-icon-arrow-down el-icon--right"></i>
                </el-button>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="handleExport('full')">Full Data</el-dropdown-item>
                    <el-dropdown-item @click.native="handleExport('headersOnly')">Headers Only</el-dropdown-item>
                    <el-dropdown-item @click.native="handleExport('headers')">QB Template</el-dropdown-item>
                </el-dropdown-menu>
            </el-dropdown>
            <v-progress-linear v-if="progress > 0" class="mt-2" style="float:right;" color="light-blue" height="15" v-model="progress">
                <small class="white--text">{{ Math.ceil(progress) }}%</small>
            </v-progress-linear>
        </template>
        <template #body>
            <e-table :data="messageItems" :total="messageItems.length" :headers="messageHeaders" :height="window.height - 170" :loading="messageLoading">
                <template #actions="{scope}">
                    <small class="mr-2" v-if="scope.row.isLoading"><i class="el-icon-loading"></i> exporting</small>
                    <router-link target="_blank" :to="`/edi-preview?messageId=${scope.row.id}&attachmentId=${scope.row.attachmentId}`">
                        <el-button size="mini" type="primary">Preview</el-button>
                    </router-link>
                    <el-dropdown class="ml-2" :disabled="disableFilter" trigger="click">
                        <el-button size="mini" type="primary">
                            Export <i class="el-icon-arrow-down el-icon--right"></i>
                        </el-button>
                        <el-dropdown-menu slot="dropdown">
                            <el-dropdown-item @click.native="exportByRow(scope.row, 'full')">Full Data</el-dropdown-item>
                            <el-dropdown-item @click.native="exportByRow(scope.row, 'headersOnly')">Headers Only</el-dropdown-item>
                            <el-dropdown-item @click.native="exportByRow(scope.row, 'headers')">QB Template</el-dropdown-item>
                        </el-dropdown-menu>
                    </el-dropdown>
                </template>

                <template #footer>
                    <el-popover placement="top-start" :width="query.length*7" trigger="click">
                        <div>
                            <span>Click-to-Copy&#8595;</span>
                            <el-button type="text" @click="onclipboardCopy">{{ query }}</el-button>
                        </div>
                        <el-button slot="reference">Email Query</el-button>
                    </el-popover>
                </template>
            </e-table>
        </template>
    </v-content-layout>
    <BrandList ref="brandRef" />
</div>
</template>

<script>
import {
    mapGetters,
    mapActions
} from 'vuex';
import * as type from '../../store/types';

import { generateExcelFile, getBrandInfo, loadBrandInfo } from '../../services/excelGeneratorSvc';
import FilterOption from './components/FilterOption';
import BrandList from './components/BrandList';
export default {
    components: {
        FilterOption,
        BrandList
    },
    data: () => ({
        brandName: '',
        exportData: [],
        exportHeaders: [{
                header: "VENDOR NAME",
                key: 'vendorName',
                width: '20'
            },
            {
                header: "BILL NO",
                key: 'invoiceNumber',
                width: '20'
            },
            {
                header: "BILL DATE",
                key: 'invoiceDate',
                width: '20'
            },
            {
                header: "TERMS",
                key: 'netTerm',
                width: '15'
            },
            {
                header: "CATEGORY",
                key: 'category',
                width: '15'
            },
            {
                header: "DESCRIPTION",
                key: 'poNumber',
                width: '20'
            },
            {
                header: "AMOUNT",
                key: 'invoiceTotal',
                width: '20'
            },
            {
                header: "CLASS",
                key: 'className',
                width: '15'
            },
            {
                header: "Brand (This column not included in QB Importing)",
                key: 'brandName',
                width: '40'
            }
        ],
        exportHeadersOnly: [{
                header: "Brand",
                key: 'brandName'
            },
            {
                header: "Invoice No.",
                key: 'invoiceNumber'
            },
            {
                header: "Invoice Date",
                key: 'invoiceDate'
            },
            {
                header: "PO No.",
                key: 'poNumber'
            },
            {
                header: "PO Date",
                key: 'ipoDate'
            },
            {
                header: "Total Amount",
                key: 'totalAmount'
            },
            {
                header: "Freight Charge",
                key: 'allowanceAndChargesAmount'
            },
            {
                header: "Invoice Total",
                key: 'invoiceTotal'
            },
            {
                header: "Total Qty",
                key: 'totalQuantity'
            },
            {
                header: "Ship To",
                key: 'shipTo'
            },
            {
                header: "Bill To",
                key: 'billTo'
            },
        ],
        exportFullHeaders: [{
                header: "Brand",
                key: 'brandName'
            },
            {
                header: "Invoice No.",
                key: 'invoiceNumber'
            },
            {
                header: "Invoice Date",
                key: 'invoiceDate'
            },
            {
                header: "PO No.",
                key: 'poNumber'
            },
            {
                header: "PO Date",
                key: 'ipoDate'
            },
            {
                header: "Total Amount",
                key: 'totalAmount'
            },
            {
                header: "Freight Charge",
                key: 'allowanceAndChargesAmount'
            },
            {
                header: "Invoice Total",
                key: 'invoiceTotal'
            },
            {
                header: "Total Qty",
                key: 'totalQuantity'
            },
            {
                header: "Ship To",
                key: 'shipTo'
            },
            {
                header: "Bill To",
                key: 'billTo'
            },
            {
                header: "Line",
                key: 'line'
            },
            {
                header: "Vendor No.",
                key: 'vendorNumber'
            },
            {
                header: "UPC No.",
                key: 'upcNumber'
            },
            {
                header: "Buyer No.",
                key: 'buyerNumber'
            },
            {
                header: "Qty",
                key: 'quantity'
            },
            {
                header: "Unit of Measure",
                key: 'unitOfMeasure'
            },
            {
                header: "Unit Price",
                key: 'unitPrice'
            },
            {
                header: "Case Pack",
                key: 'casePack'
            },
            {
                header: "Extended Price",
                key: 'extendedPrice'
            }
        ],
        exportLoading: false,
        exportFormat: '',
        progress: 0,
        exportLoading: false,
        query: ''
    }),
    computed: {
        ...mapGetters({
            messageHeaders: 'ediInvoice/getMessageHeaders',
            messageItems: 'ediInvoice/getMessageItems',
            messageLoading: 'ediInvoice/getMessageLoading',
            disableFilter: 'ediInvoice/getDisableFilter'
        }),
        threads: {
            get: function () {
                return this.messageItems
            },
            set: function (value) {
                if (value) {
                    return this.messageItems
                }
            }
        }
    },
    methods: {
        ...mapActions({
            loadMessages: `ediInvoice/${type.GMAIL_LOAD_MESSAGES}`
        }),
        calculateProgressPercentage(partialValue, totalValue) {
            return (100 * partialValue) / totalValue
        },
        handleExport: async function (data) {
            this.exportFormat = data
            this.recursiveFunction(this.threads)
        },
        async recursiveFunction(items, index = 0) {
            try {
                this.exportLoading = true;
                if (index === items.length) {
                    this.progress = this.calculateProgressPercentage(index, items.length)
                    this.exportLoading = false;
                    console.log('done!')

                    let brands = await loadBrandInfo();
                    let exportData = await Promise.all(this.exportData.map(async e => {
                        let brand = await getBrandInfo(this.brandName, e.poNumber, brands)
                        return {
                            ...e,
                            brandName: brand.brandName,
                            vendorName: brand.vendorName,
                            className: brand.className,
                            category: brand.category,
                            netTerm: brand.netTerm
                        }
                    })) 

                    if (this.exportFormat === 'headers') {
                        await generateExcelFile(`EDI-Export-QB-Template_${Date.now()}`, 'Template', this.exportHeaders, exportData)
                    } else if (this.exportFormat === 'full') {
                        await generateExcelFile(`EDI-Export-Full-Data_${Date.now()}`, 'Sheet1', this.exportFullHeaders, exportData)
                    } else if (this.exportFormat === 'headersOnly') {
                        await generateExcelFile(`EDI-Export-Headers-Only_${Date.now()}`, 'Sheet1', this.exportHeadersOnly, exportData)
                    }
                    this.exportData = []
                    this.progress = 0
                } else {
                    this.progress = this.calculateProgressPercentage(index, items.length)
                    try {
                        let response = await this.$http.get(`/gmail/attachment?attachmentId=${items[index].attachmentId}&messageId=${items[index].messageId}&format=${this.exportFormat}`);
                        console.log(response.data)
                        this.exportData = [...this.exportData, ...response.data.result]
                    } catch (error) {
                        console.log(error)
                    } finally {
                        await this.recursiveFunction(items, (index + 1))
                    }
                }
            } catch (error) {
                console.log(result)
                this.$message({
                    type: "error",
                    message: error.message
                })
            }
        },
        async exportByRow(items, format) {
            try {
                let response = await this.$http.get(`/gmail/attachment?attachmentId=${items.attachmentId}&messageId=${items.messageId}&format=${format}`);
                console.log(response.data)
                this.exportData = response.data.result

                let brands = await loadBrandInfo();
                let modifiedExportData = await Promise.all(this.exportData.map(async e => {
                    let brand = await getBrandInfo(this.brandName, e.poNumber, brands);
                    return {
                        ...e,
                        brandName: brand.brandName,
                        vendorName: brand.vendorName,
                        className: brand.className,
                        category: brand.category,
                        netTerm: brand.netTerm
                    }
                }))
                if (format === 'headers') {
                    await generateExcelFile(`EDI-Export-QB-Template_${Date.now()}`, 'Template', this.exportHeaders, modifiedExportData)
                } else if (format === 'full') {
                    await generateExcelFile(`EDI-Export-Full-Data_${Date.now()}`, 'Sheet1', this.exportFullHeaders, modifiedExportData)
                } else if (format === 'headersOnly') {
                    await generateExcelFile(`EDI-Export-Headers-Only_${Date.now()}`, 'Sheet1', this.exportHeadersOnly, modifiedExportData)
                }
                this.exportData = []
            } catch (error) {
                console.log(error)
            }
        },
        onFilter(data) {
            this.brandName = data.brand
            this.loadMessages(data)
                .then(({
                    query
                }) => {
                    this.query = query.substring(2)
                })
        },
        onclipboardCopy() {
            this.$clipboard(this.query)
            this.$message({
                type: 'success',
                message: 'Email Query copied to clipboard!',
                duration: 5000
            })
        },
        onViewParsers() {
            this.$refs['brandRef'].onOpenDialog();
        }
    }
}
</script>
